// src/components/Services/ServiceOrders/ServiceOrderStatusBadge.tsx
import {
  ServiceOrderStatus,
  SERVICE_ORDER_STATUS_LABELS,
  SERVICE_ORDER_STATUS_COLORS,
} from '@/types/service';
import { cn } from '@/lib/utils';

interface ServiceOrderStatusBadgeProps {
  status: ServiceOrderStatus;
  className?: string;
}

export function ServiceOrderStatusBadge({ status, className }: ServiceOrderStatusBadgeProps) {
  if (!status || !(status in SERVICE_ORDER_STATUS_COLORS)) {
    return null;
  }

  const label = SERVICE_ORDER_STATUS_LABELS[status] ?? status;
  const color = SERVICE_ORDER_STATUS_COLORS[status] ?? 'bg-gray-100 text-gray-600';

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        color,
        className,
      )}
    >
      {label}
    </span>
  );
}
